import { getQrcodeIndex } from 'services';
import { Toast } from 'antd-mobile';

export default {
  namespace: 'home',
  state: {
    data: {},
  },
  effects: {
    *queryQrcodeIndex({ payload, callback }, { call, put }) {
      const response = yield call(getQrcodeIndex, payload);
      // 01 - 异常，02 - 没权限  token不对，03 - 禁止访问
      if (
        response.data.state === '01' ||
        response.data.state === '02' ||
        response.data.state === '03'
      ) {
        Toast.fail(response.data.note, 3);
        return;
      }

      if (response.data.state === '11') {
        const data = response.data.data;
        const { token, gq, card } = data;
        localStorage.setItem('token', `Bearer ${token}`);
        localStorage.setItem('gq', gq);
        localStorage.setItem('agentId', card.agentId);
        localStorage.setItem('homeData', JSON.stringify(data));
        window.localStorage.wmUserInfo = JSON.stringify({ userId: card.agentId });
        yield put({
          type: 'setData',
          payload: {
            data,
          },
        });
        callback && callback(data);
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
